
document.addEventListener('Searchanise.Loaded', function() {
  (function($) {

    $(document).on("Searchanise.RecommendationUpdated", function (event, recommendations) {
      if (navigator.vendor.match(/[Aa]+pple/g) != null && navigator.vendor.match(/[Aa]+pple/g).length > 0) {
        console.log("searchanise");
        $(recommendations).data('plugin_tinycarousel').options.animationTime = 0;
      }
    });
  })(window.Searchanise.$);
})